export const ACTIONS_FETCH: string = 'ACTIONS_FETCH'
export const ACTIONS_FETCH_REQUEST: string = 'ACTIONS_FETCH_REQUEST'
export const ACTIONS_FETCH_ERROR: string = 'ACTIONS_FETCH_ERROR'
export const ACTIONS_FETCH_SUCCESS: string = 'ACTIONS_FETCH_SUCCESS'

export const ACTION_SET: string = 'ACTION_SET'
export const ACTION_SET_REQUEST: string = 'ACTION_SET_REQUEST'
export const ACTION_SET_ERROR: string = 'ACTION_SET_ERROR'
export const ACTION_SET_SUCCESS: string = 'ACTION_SET_SUCCESS'
